import { useContext } from 'react';
import { LotteryContext } from '.';

export const useLottery = () => {
	return useContext(LotteryContext);
};
